"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconLumper = function SvgIconLumper(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "lumper icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Lumper Icon'), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "nonzero",
    d: "M28.207 7.454C28.207 5.547 29.78 4 31.72 4c1.938 0 3.512 1.547 3.512 3.454 0 1.908-1.574 3.453-3.512 3.453-1.94 0-3.513-1.545-3.513-3.453zM11.43 10.466h10.835c.177 0 .34.09.43.243l1.844 3.003c.01.013.014.029.02.043a.126.126 0 01.015.039.451.451 0 01.037.17v2.742l3.826-3.45a3.666 3.666 0 013.613-1.77c2.017.251 3.444 2.061 3.19 4.044l-1.695 12.112-.023-.002 5.225 12.91c.486 1.214-.088 2.51-1.25 2.962-1.135.441-2.407-.08-2.899-1.16l-4.71-11.384-2.066 11.318a2.27 2.27 0 01-2.623 1.675c-1.232-.224-2.042-1.395-1.795-2.679l2.854-14.62h.019l.977-6.99-2.641 2.284v2.838a.496.496 0 01-.5.494H9.588a.497.497 0 01-.502-.494V13.988c0-.006-.008-.012-.008-.02a.541.541 0 01.11-.313l1.813-2.946a.492.492 0 01.429-.243zm5.92.992v2.012h5.87l-1.235-2.012zm-5.636 0L10.48 13.47h5.867v-2.012zm-1.623 3.003v9.837h13.515V22.8h-7.182c-1.166-.024-2.04-.918-2.021-2 .022-1.052.88-1.893 1.937-1.923h5.866l1.4-1.263V14.46z"
  }));
};

var _default = SvgIconLumper;
exports.default = _default;